import React from 'react'
import { Box, Typography } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

import useStyles from './styles'

const ActivitiesInfoBanner = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <InfoOutlinedIcon className={classes.icon} fontSize="small" />
      <Typography className={classes.text}>
        Aqui você define as permissões de Atividades para este perfil. Atenção:
        mesmo que o perfil não tenha permissão de visualização marcada, o
        usuário continuará vendo as atividades em que for atribuído como
        responsável — manual ou automaticamente por outros módulos. Isso garante
        que ninguém fique sem acesso a uma atividade pela qual é responsável.
      </Typography>
    </Box>
  )
}

export default ActivitiesInfoBanner
